import { Message } from "element-ui"
export const formatImgUrl = (url) => {
  if(url){
    if (url.startsWith('http') || url.startsWith('https')) {
        return url
    }
    return `https://img.zczy56.com/${url}`
  }
  return url
}

export const copyText = (data) => {
  const url = data;
  const oInput = document.createElement('input');
  oInput.value = url;
  document.body.appendChild(oInput);
  oInput.select();
  document.execCommand('Copy');
  Message({
    message: '复制成功',
    type: 'success'
  });
  oInput.remove();
};




 
